/* eslint-disable array-callback-return */
import React from 'react';
import "./SectionStyles/Sections.css"
import CardG from '../Cards/CardG';
import CardG1 from '../Cards/CardG1';

const SectionG = (props) => {
  const CardTheme = [
    {
      value: 2,
    }
  ];

  const cardData = [
    {
      name: 'Super Charged Twister',
      price: '250',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339408-Double-Decker.jpg&w=256&q=75',
      des: '1 Regular Pizza  + 2 Pcs Cheese Garlic Bread + 2 Drink 345ML',
      id: 2468,
    },
    {
      name: 'CardG 2',
      price: '150',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339408-Double-Decker.jpg&w=256&q=75',
      des: 'Description of CardG 2',
      id: 1357,
    },
    {
      name: 'CardG 3',
      price: '150',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339408-Double-Decker.jpg&w=256&q=75',
      des: 'Description of CardG 2',
      id: 1357234,
    },
    {
      name: 'CardG 4',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339408-Double-Decker.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 101912,
    }
    ,
    {
      name: 'CardG 5',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 79273,
    }
    ,
    {
      name: 'CardG 6',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 72437098,
    }
    ,
    {
      name: 'CardG 7',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 7327409,
    }
    ,
    {
      name: 'CardG 9',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 37632,
    }
    ,
    {
      name: 'CardG 10',
      price: '200',
      img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
      des: 'Description of CardG 3',
      id: 638688,
    }
    ,
    // {
    //   name: 'CardG 11',
    //   price: '200',
    //   img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
    //   des: 'Description of CardG 3',
    //   id: 39853,
    // }
    // ,
    // {
    //   name: 'CardG 12',
    //   price: '200',
    //   img: 'https://www.kaybees.com.pk/_next/image?url=https%3A%2F%2Fassets.indolj.io%2Fimages%2F1652339346-Super-Save.jpg&w=256&q=75',
    //   des: 'Description of CardG 3',
    //   id: 5463,
    // }
  ];
  return (
    <>
      {CardTheme.map((theme) => {

        if (theme.value === 1) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardG1
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
        else if (theme.value === 2) {
          return (
            <div id={props.id} key={theme.value} className='main-main'>
              <h1>{props.Heading}</h1>
              <div className='main'>
                {cardData.map((data, id) => (
                  <CardG
                    key={id}
                    id={data.id}
                    name={data.name}
                    price={data.price}
                    img={data.img}
                    des={data.des}
                  />
                ))}
              </div>
            </div>
          )
        }
      }
      )
      }
    </>
  );
};
SectionG.defaultProps = {
  Heading: "Section G",
  id:'sectionG'
}
export default SectionG;
